import { Observable } from 'rxjs/Rx';
export class BrowserViewports {
/**
 * @return {?}
 */
static getBrowserViewports(): any {
    return {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth
    };
  }
/**
 * @return {?}
 */
static onBrowserViewportsUpdate() {
    return Observable.fromEvent(window, 'resize')
      .debounceTime(500)
      .map(() => {
        return this.getBrowserViewports();
      });
  }
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
